const config =  {
  apiEndpoints: {
    accountUri: process.env.VUE_APP_API_URI.concat('account/'),
    usersUri: process.env.VUE_APP_API_URI.concat('users/'),    
    acquirersUri: process.env.VUE_APP_API_URI.concat('acquirers/'),
    deviceContractUri: process.env.VUE_APP_API_URI.concat('deviceContract/'),
    payoutIntervalUri: process.env.VUE_APP_API_URI.concat('payoutInterval/'),    
    salesmenUri: process.env.VUE_APP_API_URI.concat('salesmen/'),
    banksUri: process.env.VUE_APP_API_URI.concat('banks/'),
    
    transactionTypeUri: process.env.VUE_APP_API_URI.concat('transactiontypes/'),
    transactionStatusUri: process.env.VUE_APP_API_URI.concat('transactionstatuses/'),
    anticipationTypeUri: process.env.VUE_APP_API_URI.concat('anticipationtypes/'),    

    
    paymentsUri: process.env.VUE_APP_API_URI.concat('payments/'),
    auditingUri: process.env.VUE_APP_API_URI.concat('auditing/'),
    cashTransactionUri: process.env.VUE_APP_API_URI.concat('cash/'),
    
    //new
    anticipationUri: process.env.VUE_APP_TRANSACTIONS_API_URI.concat('anticipation/'),
    transactionsUri: process.env.VUE_APP_TRANSACTIONS_API_URI.concat('transaction/'),
    transactionEntryPointUri: process.env.VUE_APP_API_GATEWAY_URI.concat('entrypoint/transactions/'),
    entriesEntryPointUri: process.env.VUE_APP_API_GATEWAY_URI.concat('entrypoint/entries/'),
    balanceUri: process.env.VUE_APP_API_GATEWAY_URI.concat('entrypoint/transactions/balance/'),

    usersUri: process.env.VUE_APP_API_GATEWAY_URI.concat('customers/users/'),
    salesPersonUri: process.env.VUE_APP_API_GATEWAY_URI.concat('customers/salespeople/'),
    sellersUri: process.env.VUE_APP_API_GATEWAY_URI.concat('customers/sellers/'),
    partnersUri: process.env.VUE_APP_API_GATEWAY_URI.concat('customers/partners/'),
    bankAccountUri: process.env.VUE_APP_API_GATEWAY_URI.concat('customers/bankAccounts/'),
    
    contractUri: process.env.VUE_APP_API_GATEWAY_URI.concat('contracts/'),
    contractExportUri: process.env.VUE_APP_CONTRACT_EXPORT_URI,
    paymentMethodUri: process.env.VUE_APP_API_GATEWAY_URI.concat('paymentmethods/'),
    paymentMethodTypeUri: process.env.VUE_APP_API_GATEWAY_URI.concat('paymentmethods/paymentmethodtypes/'),

    deviceModelsUri: process.env.VUE_APP_API_GATEWAY_URI.concat('devices/devicemodels/'),
    devicesUri: process.env.VUE_APP_API_GATEWAY_URI.concat('devices/'),
    deviceRentalChargesUri: process.env.VUE_APP_API_GATEWAY_URI.concat('devices/devicerentalcharges/'),

    paymentLinksUri: process.env.VUE_APP_API_GATEWAY_URI.concat('paymentLinks/'),
    moneyOutUri: process.env.VUE_APP_API_GATEWAY_URI.concat('moneyflows/api/moneyouts/'),
    moneyOutGroupUri: process.env.VUE_APP_API_GATEWAY_URI.concat('moneyflows/api/moneyOutGroups/'),
    withdrawalsUri: process.env.VUE_APP_API_GATEWAY_URI.concat('moneyflows/api/withdrawals/'),
    billPaymentUri: process.env.VUE_APP_API_GATEWAY_URI.concat('moneyflows/api/billpayments/'),
    bankTransferUri: process.env.VUE_APP_API_GATEWAY_URI.concat('moneyflows/api/banktransfers/'),
    pixTransferUri: process.env.VUE_APP_API_GATEWAY_URI.concat('moneyflows/api/pixtransfers/'),
    viaCepUri: process.env.VUE_APP_VIACEP_URI,
    cnaeListUri: process.env.VUE_APP_CNAE_URI,
    bankListUri: process.env.VUE_APP_BANKS_URI,
    mccListUri: process.env.VUE_APP_MCC_URI
  },
  currentPartnerKey: process.env.VUE_APP_PARTNER_KEY,
  partnersConfiguration: {},
  partnersList: [
    {
      key: 'D3PAY',
      name: 'D3 Pagamentos',
      apptitle: 'Portal D3',
      images: {
        header: {
          width: 48
        }
      },
      login: {
        type: 'default'
      },
      payments: {
        paymentGroup: {
          enabled: true,
          exportType: 'cnab'
        },
        salesPerson: false
      },
      contracts: {
        exportPdf: false,
        installmentsExpanded: false,
        partnerTaxEnabled: false
      },
      transactions: {
        addCash: true
      },
      banks: {
        useDefault:  false,
        defaultBankCode: 0,
      },
      reports: {
        detailedTransactions: true,
        statement: true,
        receivableTransactions: true,
        showTransactionDetailLink: true
      },
      devices: {
        usage: {
          enabled: true
        },
        rentalCharge: {
          enabled : true
        },
        export: true
      },
      sellers: {
        fakeData: false,
        paymentLink: true,
        statement: true
      }
    },
    {
      key: 'STER',
      name: 'Ster Connect',
      apptitle: 'Portal Ster',
      images: {
        header: {
          width: 120
        }
      },
      login: {
        type: 'default'
      },
      payments: {
        paymentGroup: {
          enabled: true,
          exportType: 'cnab'
        },
        salesPerson: false
      },
      contracts: {
        exportPdf: false,
        installmentsExpanded: false,
        partnerTaxEnabled: false
      },
      transactions: {
        addCash: false
      },
      banks: {
        useDefault:  false,
        defaultBankCode: 0,
      },
      reports: {
        detailedTransactions: true,
        statement: true,
        receivableTransactions: true,
        showTransactionDetailLink: true
      },
      devices: {
        usage: {
          enabled: true
        },
        rentalCharge: {
          enabled : true
        },
        export: true
      },
      sellers: {
        fakeData: false,
        paymentLink: true,
        statement: false
      }
    },
    {
      key: 'AFINZ',
      name: 'Afinz Empresas',
      apptitle: 'Portal Afinz',
      images: {
        header: {
          width: 80
        }
      },
      login: {
        type: 'default'
      },
      payments: {
        paymentGroup: {
          enabled: true,
          exportType: 'cnab'
        },
        salesPerson: false
      },
      contracts: {
        exportPdf: false,
        installmentsExpanded: false,
        partnerTaxEnabled: false
      },
      transactions: {
        addCash: true
      },
      banks: {
        useDefault:  false,
        defaultBankCode: 0,
      },
      reports: {
        detailedTransactions: true,
        statement: true,
        receivableTransactions: true,
        showTransactionDetailLink: true
      },
      devices: {
        usage: {
          enabled: true
        },
        rentalCharge: {
          enabled : true
        },
        export: true
      },
      sellers: {
        fakeData: false,
        paymentLink: true,
        statement: true
      }
    },
    {
      key: 'RECEBATECH',
      name: 'Receba Tech',
      apptitle: 'Portal Receba Tech',
      images: {
        header: {
          width: 80
        }
      },
      login: {
        type: 'default'
      },
      payments: {
        paymentGroup: {
          enabled: true,
          exportType: 'cnab'
        },
        salesPerson: false
      },
      contracts: {
        exportPdf: false,
        installmentsExpanded: false,
        partnerTaxEnabled: false
      },
      transactions: {
        addCash: true
      },
      banks: {
        useDefault:  false,
        defaultBankCode: 0,
      },
      reports: {
        detailedTransactions: true,
        statement: true,
        receivableTransactions: true,
        showTransactionDetailLink: true
      },
      devices: {
        usage: {
          enabled: true
        },
        rentalCharge: {
          enabled : true
        },
        export: true
      },
      sellers: {
        fakeData: false,
        paymentLink: true,
        statement: true
      }
    }
  ],
  currentPartner: function() {
    const self = this;
    return this.partnersList.find(function (el) {
      return el.key == self.currentPartnerKey; 
    });
  }
}

config.partnersConfiguration = config.currentPartner();
export {config as default};

